import { useEffect } from "react";
import * as R from "ramda";

export function usePaginationLogic({
  candidates,
  filters,
  filtersUsed,
  handleFiltersChange,
  loading,
  mappedMetadata
}) {
  useEffect(() => {
    if (
      filtersUsed.page &&
      filters.page > 1 &&
      !loading &&
      R.isEmpty(candidates) &&
      mappedMetadata
    ) {
      handleFiltersChange("page")(1);
    }
  }, [
    filtersUsed.page,
    candidates,
    filters.page,
    handleFiltersChange,
    loading,
    mappedMetadata
  ]);
}
